import React, { Component, useState } from 'react';
import { render } from 'react-dom';

import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from 'react-places-autocomplete';

import MapWithInfoBox from './MapWithInfoBox';

const AutoComplete = (props) => {

    const [address, setAddress] = useState("");
    const [coordinates, setCoordinates] = useState({ lat: null, long: null });

    const handleSelect = async value => {
        const results = await geocodeByAddress(value);
        const ll = await getLatLng(results[0]);

        setAddress(value);
        setCoordinates(ll);
        if (props.setCoodinationValueAddress) {
            props.setCoodinationValueAddress(results);
        } else {
            console.log(results);
            props.setCoodinationValue(value, ll);
        }

        //console.log(value);
        //console.log(ll);
        //getSearchInput(value,ll);
    };

    if (MapWithInfoBox) {
        return (
            <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelect}
            >
                {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading
                }) => (
                    <div
                        key={suggestions.description}
                    >
                        <input
                            style={{ width: "200px" }}
                            {...getInputProps({
                                placeholder: 'Search Location...',
                                className: 'location-search-input',
                                'name': 'form-control search_location'
                            })}
                        />
                        <span className="fa fa-map-marker heart-icon-post-listing errspan"></span>
                        <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map(suggestion => {
                                const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                    ? { backgroundColor: '#ffffff', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                return (


                                    <div id="infowindow-content"
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style
                                        })}
                                        key={suggestion.placeId}
                                    >
                                        <span className="place-address">{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        )
    }
}

export default AutoComplete